/* jshint esversion: 6 */
import React from 'react';
import PropTypes from 'prop-types';
import Modal from 'app/components/common/Modal.jsx';
import CreditCardModal from 'app/components/Subscription/CreditCardModal.jsx';
import StyledSelect from 'app/components/common/StyledSelect.jsx';
import FormUtilityMixin from 'app/mixins/FormUtilityMixin.js';
import * as _ from 'underscore';
import PricingModule from 'app/mixins/PricingModule.jsx';
import GetPlanData from 'app/utility/GetPlanData.js';
import { Link } from 'react-router-dom';

class SubscriptionPauseModal extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            userPlanData: [],
            firstPullFlag: props.app.config.constants.FIRSTPULL_SINGLE,
            selectedPlan: {},
            showCCModal: false,
            downgrading: false,
            couponCode: ''
        };

        this.downgradeUser = this.downgradeUser.bind(this);
        this.choosePlan = this.choosePlan.bind(this);
        this.addPayment = this.addPayment.bind(this);
        this.renderPauseModal = this.renderPauseModal.bind(this);
        this.changeTerm = this.changeTerm.bind(this);

    }

    componentDidMount() {

        this.props.getPlans();

        if (dataLayer) {
            dataLayer.push({
                'event': 'checkout',
                'ecommerce': {
                    'checkout': {
                        'actionField': {'step': 1, 'option': 'Resubscribe'}
                    }
                }
            });
        }

        if (mixpanel) {
            mixpanel.track("Subscription Pause Modal");
        }

        if (this.props.recordEvent) {
            this.props.recordEvent({
                pub_id: this.props.user.detail.id,
                event_name: 'Subscription Pause Modal'
            });
        }

    }

    componentDidUpdate(prevProps, prevState) {
        let plans = this.props.plans.details,
            constants = this.props.app.config.constants,
            validPlans = [
                constants.PUB_LEVEL_16, // starter
                constants.PUB_LEVEL_15, // basic
                constants.PUB_LEVEL_6,  // pro
                constants.PUB_LEVEL_9,  // plus
                constants.PUB_LEVEL_8   // agency
            ],
            planOptions = [],
            hasCoupon = false,
            couponCode = '';

        if (!_.isEmpty(plans)) {
            if (this.props.app.configLoaded && this.props.app.userLoaded && this.state.userPlanData.length === 0) {
                // check if a coupon code was passed in
                // if so show all the options and validate the coupon against the term to get the discounts
                if (this.props.router.query !== null && this.props.router.query.code !== undefined) {
                    hasCoupon = true;
                    couponCode = this.props.router.query.code;
                }

                for (let key in validPlans) {
                    let plan = plans[validPlans[key]],
                        monthlyPlan = {
                            level: validPlans[key],
                            term: constants.SUBSCRIPTION_TERM_MONTHLY,
                            addOns: 0,
                            price: 0,
                        },
                        annualPlan = {
                            level: validPlans[key],
                            term: constants.SUBSCRIPTION_TERM_ANNUAL,
                            addOns: 0,
                            price: 0
                        },
                        inputsRequired = parseInt(this.props.user.perms.resources.inputsInUse, 10),
                        outputsRequired = parseInt(this.props.user.perms.resources.outputsInUse, 10),
                        planInputs = parseInt(plan.limits.hardLimitInputs, 10),
                        planOutputs = parseInt(plan.limits.hardLimitOutputs, 10),
                        addOnInputs = 0,
                        addOnOutputs = 0;

                    if (plan.addOnQuantity[constants.SUBSCRIPTION_ADDON_SOCIALS] && plan.addOnQuantity[constants.SUBSCRIPTION_ADDON_SOCIALS].feeds) {
                        addOnInputs = plan.addOnQuantity[constants.SUBSCRIPTION_ADDON_SOCIALS].feeds;
                    }

                    if (plan.addOnQuantity[constants.SUBSCRIPTION_ADDON_SOCIALS] && plan.addOnQuantity[constants.SUBSCRIPTION_ADDON_SOCIALS].socials) {
                        addOnOutputs = plan.addOnQuantity[constants.SUBSCRIPTION_ADDON_SOCIALS].socials;
                    }

                    if ([constants.PUB_LEVEL_16, constants.PUB_LEVEL_15].indexOf(validPlans[key]) === -1) {
                        while ((planInputs + (addOnInputs * monthlyPlan.addOns)) < inputsRequired || (planOutputs + (addOnOutputs * monthlyPlan.addOns)) < outputsRequired) {
                            monthlyPlan.addOns++;
                        }

                        while ((planInputs + (addOnInputs * annualPlan.addOns)) < inputsRequired || (planOutputs + (addOnOutputs * annualPlan.addOns)) < outputsRequired) {
                            annualPlan.addOns++;
                        }

                        monthlyPlan.price = parseFloat((plan.price[constants.SUBSCRIPTION_TERM_MONTHLY] + (plan.addOnPrices[constants.SUBSCRIPTION_ADDON_SOCIALS][constants.SUBSCRIPTION_TERM_MONTHLY] * monthlyPlan.addOns)).toFixed(2));
                        annualPlan.price = parseFloat((plan.price[constants.SUBSCRIPTION_TERM_ANNUAL] + (plan.addOnPrices[constants.SUBSCRIPTION_ADDON_SOCIALS][constants.SUBSCRIPTION_TERM_ANNUAL] * annualPlan.addOns)).toFixed(2));
                    } else {
                        if ((planInputs + (addOnInputs * monthlyPlan.addOns)) < inputsRequired || (planOutputs + (addOnOutputs * monthlyPlan.addOns)) < outputsRequired) {
                            continue;
                        }
                        monthlyPlan.price = plan.price[constants.SUBSCRIPTION_TERM_MONTHLY];
                        annualPlan.price = plan.price[constants.SUBSCRIPTION_TERM_ANNUAL];
                    }

                    planOptions.push(monthlyPlan);
                    planOptions.push(annualPlan);

                    if (hasCoupon) {
                        this.props.validateCoupon({
                            code: couponCode,
                            plan: 'all'
                        });
                    }

                }

                // try to default to pro
                let selectedPlan = {}
                if (this.props.newSubscription !== undefined) {
                    let index = -1;
                    for (let i = 0; i < planOptions.length; ++i) {
                        if (planOptions[i].level === this.props.newSubscription.level && planOptions[i].term === this.props.newSubscription.term) {
                            index = i;
                            break;
                        }
                    }
                    if (index >= 0) {
                        selectedPlan = planOptions[index];
                    }
                } else {
                    if (planOptions.length === 8) {
                        selectedPlan = planOptions[4];
                    } else {
                        selectedPlan = planOptions[1];
                    }
                }
                
                if (planOptions.length) {
                    this.setState({
                        userPlanData: planOptions,
                        selectedPlan: selectedPlan
                    });
                }


            }
        }

        if (prevProps && prevProps.app.loading.SUB_VALIDATE_COUPON === true && this.props.app.loading.SUB_VALIDATE_COUPON === false) {
            if (this.state.userPlanData) {
                let coupon = this.props.plans.validatedCoupon,
                    nextOptions = [...this.state.userPlanData],
                    nextSelectedPlan = this.state.selectedPlan;

                for (let i = 0; i < nextOptions.length; ++i) {
                    let planDetail = GetPlanData.lookupDetails(nextOptions[i].level, nextOptions[i].term);
                    if (coupon.discount !== undefined && (coupon.discount.appliesToAllPlans || coupon.discount.plans.find((plan) => { return plan.code === planDetail.plan_id}))) {
                        if (coupon.discount.type === "fixed") {
                            nextOptions[i].price = nextOptions[i].price - coupon.discount.currencies[0].amount;
                            nextOptions[i].discounted = true;
                            nextSelectedPlan = nextOptions[i];
                        } else if (coupon.discount.type === "percent") {
                            let discount = ((100 - coupon.discount.percent) / 100);
                            nextOptions[i].price = nextOptions[i].price * discount;
                            nextOptions[i].discounted = true;
                            nextSelectedPlan = nextOptions[i];
                        }
                    }
                }

                this.setState({
                    userPlanData: nextOptions,
                    selectedPlan: nextSelectedPlan
                });

            }
        }

        if ((prevProps.app.loading.SUB_CREATE === true && this.props.app.loading.SUB_CREATE === false) ||
            (prevProps.app.loading.SUB_UPDATE === true && this.props.app.loading.SUB_UPDATE === false)) {
            // subscription has been updated reload the important bits
            this.props.getUser();
            this.props.getUserPerms();
            this.props.getRoutes();
            this.props.getSocials(true);
            this.props.getSubscription();

            // track some stuff too
            let subscription = this.props.plans.current,
                products = [];
            if (mixpanel) {
                mixpanel.track('Resubscription Created', {
                    'name': subscription.planName
                });
            }

            if (this.props.recordEvent) {
                this.props.recordEvent({
                    pub_id: this.props.user.detail.id,
                    event_name: 'Subscription Pause Modal - Resubscribe',
                    event_data: {
                        subscription: subscription.planName
                    }
                });
            }
            // if (dataLayer) {
            //     let planDetail = GetPlanData.lookupDetails(
            //         this.props.plans.current.planLevel,
            //         this.props.plans.current.planTerm
            //     );
            //
            //     products.push({
            //         'name': subscription.planName,     // Name or ID is required.
            //         'price': subscription.price,
            //         'quantity': 1,
            //         'variant': 'resubscribe'
            //     });
            //
            //     dataLayer.push({
            //         'event': 'purchase',
            //         'ecommerce': {
            //             'purchase': {
            //                 'actionField': {
            //                     'id': subscription.uuid, // Transaction ID. Required for purchases and refunds.
            //                     'revenue': subscription.price
            //                 },
            //                 'products': products
            //             }
            //         },
            //         // GA4 params
            //         'transaction_id': subscription.uuid,
            //         'value': subscription.price,
            //         'items': [{
            //             item_id: planDetail.plan_id,
            //             item_name: planDetail.plan_name,
            //             item_variant: 'resubscribe',
            //             quantity: 1,
            //             price: subscription.price
            //         }]
            //     });
            // }

            if (gtag) {
                let promoData = this.props.getPersistedData('gaPromo');

                gtag('event', 'purchase', {
                    transaction_id: subscription.uuid,
                    value: 1.00,
                    currency: 'USD',
                    items: [
                        {
                            item_id: 'dlvrit_1',
                            item_name: 'dlvr.it premium plan',
                            item_variant: 'Resubscribe',
                            price: 1.00,
                            quantity: 1,
                            promotion_id: (promoData && promoData.promotion_id) ? (promoData.promotion_id) : '',
                            promotion_name: (promoData && promoData.promotion_name) ? (promoData.promotion_name) : ''
                        }
                    ],

                });

                if (this.props.recordEvent) {
                    this.props.recordEvent({
                        pub_id: this.props.user.detail.id,
                        event_name: 'Resubscribe',
                        event_data: {
                            promotion_id: (promoData && promoData.promotion_id) ? (promoData.promotion_id) : '',
                            promotion_name: (promoData && promoData.promotion_name) ? (promoData.promotion_name) : ''
                        }
                    })
                }

                this.props.clearPersistedData('gaPromo');
            }

        }

    }

    componentWillUnmount() {
        this.props.resetCoupon();
    }

    addPayment(e) {
        e.preventDefault();

        // begin_checkout event for GA4 called when the credit card modal pops
        let promoData = this.props.getPersistedData('gaPromo');

        if (gtag) {
            gtag('event', 'begin_checkout', {
                currency: 'USD',
                value: 1.0,
                items: [{
                    item_id: 'dlvrit_1',
                    item_name: 'dlvr.it premium plan',
                    item_variant: 'Resubscribe',
                    price: 1.0,
                    quantity: 1,
                    promotion_id: (promoData && promoData.promotion_id) ? (promoData.promotion_id) : '',
                    promotion_name: (promoData && promoData.promotion_name) ? (promoData.promotion_name) : ''
                }],

            });
        }

        if (this.props.recordEvent) {
            this.props.recordEvent({
                pub_id: this.props.user.detail.id,
                event_name: 'Resubscribe',
                event_data: {
                    promotion_id: (promoData && promoData.promotion_id) ? (promoData.promotion_id) : '',
                    promotion_name: (promoData && promoData.promotion_name) ? (promoData.promotion_name) : ''
                }
            })
        }

        this.setState({
            showCCModal: true
        });

    }

    downgradeUser(e) {
        e.preventDefault();

        let constants = this.props.app.config.constants;

        this.props.updateSubscription({
            level: constants.PUB_LEVEL_1,
            term: constants.SUBSCRIPTION_TERM_MONTHLY,
            isHammertime: true,
            trackingAction: 'downgrade'
        });

    }

    choosePlan(e) {
        let selectedCode = e.currentTarget.value,
            plan = null,
            level = 0,
            term = 0,
            parts = selectedCode.split("-");

        level = parseInt(parts[0]);
        term = parseInt(parts[1]);

        plan = _.findWhere(this.state.userPlanData, {level: level, term: term});

        this.setState({
            selectedPlan: plan
        });

    }

    changeTerm(e) {
        let term = e.currentTarget.dataset.term,
            selectedPlan = this.state.selectedPlan;

        selectedPlan.term = term;

        this.setState({
            selectedPlan
        });

    }

    renderPauseModal() {
        let constants = this.props.app.config.constants,
            content = null,
            planOptions = [],
            plans = null,
            firstPullOptions = [
	            {value: constants.FIRSTPULL_SINGLE, label: 'Post the most recent items now'},
	            {value: constants.FIRSTPULL_OFF, label: 'Post when new items are published'},
	            {value: constants.FIRSTPULL_ON, label: 'Post all items now (up to max)'},
	        ];

        if (_.isEmpty(this.props.plans.details) || _.isEmpty(this.props.user.perms.resources) || _.isEmpty(this.props.user)) {
            return null;
        }

        for (let key in this.state.userPlanData) {
            let plan = this.state.userPlanData[key],
                termLabel = (plan.term === constants.SUBSCRIPTION_TERM_ANNUAL) ? 'year' : 'mo',
                addOns = '',
                planOption = {};

            planOption.value = `${plan.level}-${plan.term}`;
            if (plan.addOns) {
                let addOnLabel = " Add-Ons";
                if (plan.addOns === 1) {
                    addOnLabel = " Add-On";
                }
                addOns = " + " + plan.addOns + addOnLabel;
            }
            planOption.label = this.props.plans.details[plan.level].label + addOns + " $" + plan.price.toFixed(2) + " / " + termLabel;

            if (plan.discounted !== undefined && plan.discounted) {
                planOption.label += " -- Limited Offer";
            }

            planOptions.push(planOption);

        }

        plans = (
            <div className="plan-option-wrapper">
                <StyledSelect
                    options={planOptions}
                    value={`${this.state.selectedPlan.level}-${this.state.selectedPlan.term}`}
                    selectClass="large"
                    onChange={this.choosePlan}
                    bindData={true}/>
            </div>
        );

        let actionDescription = "Reactivate your plan to immediately resume posting.";

        content = (
            <div className="pause-modal-main">
                <div className="headline">
                    <p>{"We've paused all your feeds and socials."}</p>
                    <p>{actionDescription}</p>
                </div>
                {plans}
                <div className="reactivate-behavior">
                    <p>When should we post next?</p>
                    <StyledSelect
                        options={firstPullOptions}
                        linkedField={"firstPullFlag"}
                        value={this.state.firstPullFlag}
                        selectClass="large"
                        onChange={FormUtilityMixin.requestChange.bind(this)}/>
                </div>
                <div className="reactivate-button">
                    <button onClick={this.addPayment} className="btn-primary reactivate-plan">
                        Next
                    </button>
                </div>
                <div className="last-resort">
                    <Link to="/account">Delete your account</Link>
                </div>
            </div>
        );

        let headerCopy = "Oh no! Your plan has expired";
        if (this.props.headerCopy !== undefined) {
            headerCopy = this.props.headerCopy;
        }

        return (
            <Modal
                showClose={false}
                content={content}
                headerContent={headerCopy}
                wrapperClass="suspended-modal" />
        );
    }

    render() {

        if (this.state.showCCModal) {
            let addOns = null;

            if (this.state.selectedPlan.addOns > 0) {
                addOns = {
                    add_on_social: this.state.selectedPlan.addOns
                };
            }

            return (
                <CreditCardModal
                    {...this.props}
                    plan={this.state.selectedPlan.level}
                    username={this.props.user.detail.username}
                    planTerm={this.state.selectedPlan.term}
                    planPrice={this.state.selectedPlan.price}
                    firstPullFlag={this.state.firstPullFlag}
                    addOns={addOns}
                    changeTerm={this.changeTerm}
                    showClose={false} />
            );
        } else {
            return this.renderPauseModal();
        }

    }
}

SubscriptionPauseModal.displayName = "SubscriptionPauseModal";

export default PricingModule(SubscriptionPauseModal);
